// Google Analytics utility functions
export const GA_MEASUREMENT_ID = 'G-ZP6PJ58TJR';

// Initialize Google Analytics (already done in HTML, but this ensures it's available)
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
  }
};

// Generic event tracking function
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    console.log(`GA Event: ${eventName}`, parameters); // For debugging
    window.gtag('event', eventName, parameters);
  }
};

// Specific tracking functions for your buttons
export const trackCheckoutSessionStarted = (location = '') => {
  trackEvent('checkout_session_started', {
    event_category: 'engagement',
    event_label: location, // 'header' or 'cta'
    value: 1,
    currency: 'USD'
  });
};

export const trackDemoStarted = (location = '') => {
  trackEvent('demo_started', {
    event_category: 'engagement', 
    event_label: location, // 'header' or 'cta'
    value: 1
  });
};

// Additional useful tracking functions
export const trackPageView = (pagePath) => {
  trackEvent('page_view', {
    page_path: pagePath
  });
};

export const trackDownloadClick = (downloadType = '') => {
  trackEvent('download_click', {
    event_category: 'downloads',
    event_label: downloadType,
    value: 1
  });
};

export const trackSupportContact = (contactMethod = '') => {
  trackEvent('support_contact', {
    event_category: 'support',
    event_label: contactMethod,
    value: 1
  });
};

// Track successful purchases
export const trackPurchaseComplete = (value = 100) => {
  trackEvent('purchase', {
    event_category: 'ecommerce',
    event_label: 'stripe_checkout',
    value: value,
    currency: 'USD'
  });
};